import styled from 'styled-components';

export const DueDate = styled.div`
  padding: 18px 0px;
  min-width: 450px;
  text-align: center;
  & h5 {
    padding-bottom: 10px;
    color: rgb(0 0 0 / 60%);
    @media (max-width: 720px) {
      padding-top: 12px;
    }
  }
  & p {
    color: #000000ab;
    font-weight: 700;
    font-size: 36px;
    padding-bottom: 18px;
  }
  & div {
    padding: 10px 10px;
    border-radius: 10px;

    width: 100%;
    max-width: 400px;
    background-color: #fff;
    margin-bottom: 37px;
    & p {
      font-size: 15px;
      font-weight: 600;
      color: rgb(0 0 0 / 53%);
      padding: 4px 10px;
    }
  }

  & span {
    font-size: 13px;
    font-weight: bold;
    color: #ef4e5e;
    text-transform: uppercase;
    cursor: pointer;
  }
  @media (max-width: 720px) {
    text-align: center;
    min-width: 0px;
    padding: 0px;
    & div {
      margin: 0 0 20px;
    }
  }
`;
export const Recalculate = styled.span`
  display: flex;
  justify-content: center;
  margin-bottom: 9px;
`;
